import { render } from "./Trip.vue?vue&type=template&id=dae902dc&scoped=true"
import script from "./Trip.vue?vue&type=script&lang=js"
export * from "./Trip.vue?vue&type=script&lang=js"

import "./Trip.vue?vue&type=style&index=0&id=dae902dc&scoped=true&lang=css"

import exportComponent from "D:\\PROJET WEB\\carpoolear\\carpoolear_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dae902dc"]])

export default __exports__